<ng-container *ngIf="currentViewState">
  <ng-container
    odabirJedinicaFilterViewProvider
    [viewName]="currentViewName"
    [viewState]="currentViewStateFilter"
    #filter
  >
    <ng-container
      appOdabirJedinicaProvider
      [viewName]="currentViewName"
      [viewState]="currentViewState"
      [tableColumns]="tablica"
      [listColumns]="lista"
      [gridColumns]="grid"
    >
      <ntap-view-window target="globalDialog"> </ntap-view-window>
      <ntap-dynamic
        [compId]="INIT_COMP_ID"
        [class]="currentViewClass"
      ></ntap-dynamic>
      <p-button
        styleClass="mt-3"
        ntapDebounceClick
        [disabled]="(disabled$ | async) ?? true"
        label="Odaberite"
        (onClick)="selectItem()"
      />
    </ng-container>
  </ng-container>
</ng-container>
